import { TileType } from '../types';

export function isWalkable(tile: TileType): boolean {
  return tile !== TileType.Wall;
}

export function isWalkableForCat(tile: TileType): boolean {
  return tile !== TileType.Wall;
}

export function isWalkableForPlayer(tile: TileType): boolean {
  return tile !== TileType.Wall && tile !== TileType.CatDoor;
}
